import LoginApi from '../apis/authorization/login-api';

/**
 * Attempt to refresh the access token using the refresh token.
 * @param {string} refreshToken - The refresh token from Redux state
 * @returns {Promise<{token: string, refreshToken: string}>} - The new auth tokens
 * @throws {Error} - If refresh fails
 */
export async function attemptTokenRefresh(refreshToken) {
    const response = await LoginApi.getAccessToken({ refreshToken }, null);
    return {
        token: response.data.token,
        refreshToken: response.data.refreshToken || refreshToken,
    };
}
